import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=293aec76&scoped=true&"
import script from "./DocumentForm.vue?vue&type=script&lang=js&"
export * from "./DocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DocumentForm.vue?vue&type=style&index=1&id=293aec76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293aec76",
  null
  
)

export default component.exports